<div class="provider-management" ng-controller="externalEventsProviderController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>